import React from "react";
import Tabs from "@mui/material/Tabs";
import { useTheme } from "@mui/material/styles";

export default function ContainedTabs({ children, ...props }) {
	const theme = useTheme();

	return (
		<Tabs
			variant="fullWidth"
			centered
			{...props}
			sx={{
				bgcolor: "white",
				borderRadius: 2,
				minHeight: 44,
				"& .MuiTabs-indicator": {
					top: 4,
					bottom: 4,
					height: "auto",
					borderRadius: 2,

					boxShadow: theme.shadows[2],
					opacity: 0.9,
					zIndex: 0,
				},
				"& .MuiTabs-flexContainer": {
					position: "relative",
					padding: "0 3px",
					zIndex: 1,
				},
				"& .MuiTab-root": {
					minHeight: 44,
					zIndex: 1,
					transition: "color 0.3s ease",
				},
				"& .MuiTab-root.Mui-selected": {
					color: "white",
				},
				...props.sx, // permet de surcharger les styles externes
			}}
		>
			{children}
		</Tabs>
	);
}
